/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { MdOutlineStar, MdOutlineStarOutline } from 'react-icons/md';

function Star({ type }) {
  return (
    <span className="star">
      {type === 'full' ? (
        <MdOutlineStar style={{ color: '#06539A' }} />
      ) : (
        <MdOutlineStarOutline style={{ color: '#06539A' }} />
      )}
    </span>
  );
}
Star.propTypes = {
  type: PropTypes.any.isRequired,
};

function StarRating({ rating }) {
  const starRating = parseInt(rating, 10);
  const [stars, setStars] = useState([]);
  const getStarTypesArray = () => {
    const starType = [];
    if (starRating <= 0) {
      for (let i = 0; i < 5; i++) {
        starType.push('empty');
      }
    } else if (starRating > 0) {
      for (let i = 1; i <= 5; i++) {
        const isfull = i <= rating ? 'full' : 'empty';
        starType.push(isfull);
      }
    }
    setStars(starType);
  };
  useEffect(() => {
    getStarTypesArray();
  }, [rating]);
  return (
    <div className="d-flex">
      {stars.length > 0 &&
        stars.map((star, index) => <Star key={index} type={star} />)}
    </div>
  );
}

StarRating.propTypes = {
  rating: PropTypes.any.isRequired,
};

export default StarRating;
